//region 1. Platform Libraries
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
//endregion

const context = {
    router: express.Router({ mergeParams: true }),
    cameras: null,
    logger: null,
};

context.router.get('/', checkObjectID);
context.router.get('/', checkStreamIndex);
context.router.get('/', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `GET ${req.originalUrl}` });
    log('debug', JSON.stringify(req.params, null, 2));
    const _id = new MongoClient.ObjectID(req.params.id);
    context.cameras.findOne({ _id }, (findOneErr, /** @type Camera */camera) => {
        if (findOneErr) {
            log('error', findOneErr.message);
            res.status(500).send(findOneErr.message);
            return;
        }
        if (!camera) {
            const message = 'Camera Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        /** @type Stream */
        const stream = camera.streams[req.params.index];
        if (!stream) {
            const message = 'Stream Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }

        //region Get RTSP URL
        const rtspUrl = stream.rtsp_url;
        if (!rtspUrl) {
            const message = 'RTSP URL Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        log('debug', `rtspUrl ${rtspUrl}`);
        //endregion
        //region Get HTTP URL
        const username = camera.username;
        const password = camera.password;
        const hostname = camera.public_address;
        const port = camera.web_port;
        if (!hostname || !port) {
            const message = 'HTTP URL Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        let httpUrl;
        if (username) {
            httpUrl = `http://${username}:${password}@${hostname}:${port}`;
        } else {
            httpUrl = `http://${hostname}:${port}`;
        }
        log('debug', `httpUrl ${httpUrl}`);
        //endregion
        const idleTime = camera.trigger_cooldown_duration
            ? camera.trigger_cooldown_duration * 1000
            : 120000;
        const preAlarmSec = camera.prealarm_duration || 5;
        const videoDurationSec = camera.event_video_duration || 10;
        const frameRateRef = stream.frame_rate_limit || 30;
        const gopSizeRef = stream.gov_length || 100;
        const reply = {
            rtspUrl,
            httpUrl,
            idleTime,
            preAlarmSec,
            videoDurationSec,
            frameRateRef,
            gopSizeRef,
        };
        log('info', '200 OK');
        log('debug', JSON.stringify(reply, null, 2));
        res.status(200).send(reply);
    });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/event-info
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountEventInfo(options) {
    context.logger = options.logger;
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountEventInfo' });
    log('debug', 'Mounting router for /c/:/s/:/event-info....');
    options.app.use('/cameras/:id/streams/:index/event-info', context.router);
    context.cameras = options.database.collection('cameras');
    log('info', 'Router for /c/:/s/:/event-info Mounted');
}
